import NewNavbar from './Navbar'
import dotted from '../../assets/icons/lightBlueDotted.png'
import purpledotted from '../../assets/icons/purpleDotted.png'
import bigyellowdotted from '../../assets/icons/bigYellow.png'
import yellowdotted from '../../assets/icons/yellowDotted.png'
import { useEffect, useState } from 'react'
import { ChildrenProps } from '../../interfaces/common'
import Footer from './Footer'
import Metadata from '../Metadata'

const WebsiteLayout = ({ children }: ChildrenProps) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode')
    return saved ? JSON.parse(saved) : false
  })

  const landingPageMetadata = {
    title: 'Safelto - Modern Estate Management Platform',
    description:
      'Safelto is a modern estate management platform that provides secure, efficient, and user-friendly solutions for managing residential communities, guest access, and property management.',
    keywords: [
      'estate management',
      'property management',
      'residential community',
      'guest access',
      'security',
      'maintenance services',
    ],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com',
    type: 'website' as 'website',
  }
  const handleDarkModeToogle = (dark?: boolean) => {
    if (dark === undefined) {
      setIsDarkMode(!isDarkMode)
      return
    }
    setIsDarkMode(dark)
  }

  useEffect(() => {
    // Save to localStorage whenever dark mode changes
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode))

    if (isDarkMode) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [isDarkMode])

  return (
    <div
      className={`${isDarkMode ? 'dark' : ''} dark:bg-black px-4 sm:px-6 lg:px-10 overflow-hidden`}
    >
      <Metadata {...landingPageMetadata} />
      <NewNavbar toggleDarkMode={handleDarkModeToogle} isDarkMode={isDarkMode} />
      <main className="pt-[80px] min-h-dvh relative flex flex-col justify-center gap-28">
        <img
          src={dotted}
          alt=""
          className="absolute z-10 right-4 top-32 w-[27.01px] h-[15.04px] md:w-[116px] md:h-[63px] object-contain"
        />
        <img
          src={purpledotted}
          alt=""
          className="absolute z-10 lg:-left-[70px] -left-[22px] top-32 w-[27.01px] h-[15.04px] object-contain md:w-[116px] md:h-[63px]"
        />
        <img
          src={yellowdotted}
          alt=""
          className="absolute z-10 md:left-40 left-10 top-60 w-[15.5px] h-[8.41px] md:w-[64.9px] md:h-[35.24px] object-contain"
        />
        <img
          src={bigyellowdotted}
          alt=""
          className="absolute z-10 -right-8 md:-right-28 md:top-72 top-40 w-[71.88px] h-[71.88px] md:w-[301px] md:h-[301px] object-contain"
        />
        {children}
      </main>
      <Footer />
    </div>
  )
}

export default WebsiteLayout
